import {ActionTree, Module, GetterTree, MutationTree} from "vuex";
import {RootState} from "@/store/types";
import {
    getMaterialDeclarationTransactions,
    saveMaterialDeclarationTransactions,
    } from "@/services/material_declaration_transaction";
import {
    MaterialDeclarationTransactionFilter,
    materialDeclarationTransactionState,
    MaterialDeclarationTransaction
    } from "@/modules/material_declaration_transaction/types"
export const state: materialDeclarationTransactionState = {
    materialDeclarationTransaction: {
      id: 0,
      id_agreement_group: 0,
      id_supplier: 0,
      product_specific_rule : {
        name: '',
        harmonized_system_code: ''
      },
      start_application_date: new Date(),
      end_application_date: new Date(),
    },
    materialDeclarationTransactions: []
  }

const actions: ActionTree<materialDeclarationTransactionState, RootState> = {
    async GET_MATERIAL_DECLARATION_TRANSACTIONS(_, payload: MaterialDeclarationTransactionFilter) {
      return await getMaterialDeclarationTransactions(payload);
    },
    async SAVE_MATERIAL_DECLARATION_TRANSACTION(_, materialDeclarationTransactions: MaterialDeclarationTransaction[]) {
        return await saveMaterialDeclarationTransactions(materialDeclarationTransactions);
    }
}

const mutations: MutationTree<materialDeclarationTransactionState> = {
    SET_MATERIAL_DECLARATION_TRANSACTIONS(state, materialDeclarationTransactions: MaterialDeclarationTransaction[]) {
      state.materialDeclarationTransactions = materialDeclarationTransactions;
    }
}

const getters: GetterTree<materialDeclarationTransactionState, RootState> = {
    MATERIAL_DECLARATION_TRANSACTIONS(state) {
        const {materialDeclarationTransactions} = state;
        return [...materialDeclarationTransactions];
    }
}
export const material_declaration_transaction: Module<materialDeclarationTransactionState, RootState> = {
    state,
    actions,
    getters,
    mutations
}
